import { isWebViewFromCookie } from '@/utils/cookiesHelper';
import ErrorPage from '@/errorManagement/errorPages';

function DefaultErrorPageError(props) {
  return (
    <ErrorPage
      {...props}
      buttonText="Ir a movistar.es"
      buttonHref="https://www.movistar.es/"
      showButtons={!isWebViewFromCookie()}
      iconId="circulo-x"
      iconKind="m"
    />
  );
}
export default DefaultErrorPageError;
